// src/socket.js
import { io } from 'socket.io-client';
import { socketUrl } from '../Config/Config';

let socket;

export const connectSocket = (token) => {
  socket = io(socketUrl, {
    transports:['websocket'],
    auth : {
      token: token,
    },
  });

};

export const getSocket = () => socket;